module.exports = __webpack_public_path__ + "img/6995c27833ad73a3835e07c1b31561d8.png";